import React from 'react';
import { Link } from 'react-router-dom';
import unytedLogo from './images/unyted-logo-white.svg';
import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function openIntercomMessage(message) {
  return () => {
    if (window && window.Intercom) {
      window.Intercom('showNewMessage', message);
    }
  };
}

const Footer = () => (
  <footer className={styles.footer}>
    <section className="language-social">
      <div className="container">
        <div className="row">
          <div
            className={`col-xl-3 col-md-4 order-2 order-md-1 footer-social-links ${styles.socialLinksSection}`}
          >
            <img
              className={styles.unytedLogo}
              src={unytedLogo}
              alt="Unyted's logo"
            />
            <ul className={`${styles.socialLinksList} my-3`}>
              <li>
                <a
                  href="https://www.facebook.com/getunyted"
                  className="facebook"
                >
                  <FontAwesomeIcon
                    icon={['fab', 'facebook']}
                    aria-hidden="true"
                  />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/getunyted" className="twitter">
                  <FontAwesomeIcon
                    icon={['fab', 'twitter']}
                    aria-hidden="true"
                  />
                </a>
              </li>
              {/* <li><a href="https://www.youtube.com/user/getunyted/" className="youtube"><FontAwesomeIcon icon={['fab', 'youtube-play']} aria-hidden="true" /></a></li> */}
              <li>
                <a
                  href="https://www.instagram.com/getunyted/"
                  className="instagram"
                >
                  <FontAwesomeIcon
                    icon={['fab', 'instagram']}
                    aria-hidden="true"
                  />
                </a>
              </li>
            </ul>
            <div className="selectpicker">
              <Link
                className="text-white mb-2 d-inline-block"
                target="_blank"
                to="/terms-of-service-privacy-policy"
              >
                Terms of Use &amp; Privacy Policy
              </Link>
              <option>Unyted &copy; {new Date().getFullYear()}</option>
            </div>
          </div>
          <div
            className={`${styles.aboutSection} col-xl-9 col-md-8 order-1 order-md-2`}
          >
            <div className="row w-100">
              <div className="mb-3 pr-4 col-xl-3 col-sm-6">
                <h5>Unyted</h5>
                <ul>
                  <li>
                    <Link to="/the-team-method">
                      The&nbsp;Team&nbsp;Method&trade;
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-unyted">About Us</Link>
                  </li>
                  <li>
                    <a href="https://blog.unyted.co">Blog</a>
                  </li>
                </ul>
              </div>
              <div className="mb-3 pr-4 col-xl-3 col-sm-6">
                <h5>Educators</h5>
                <ul>
                  <li>
                    <Link to="/login">Sign In</Link>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="white link pointer p-0"
                      onClick={openIntercomMessage(
                        "I'm an educator and I have some questions",
                      )}
                    >
                      Support
                    </button>
                  </li>
                  <li>
                    <Link to="/educators">Learn More</Link>
                  </li>
                </ul>
              </div>
              <div className="mb-3 pr-4 col-xl-3 col-sm-6">
                <h5>Parents</h5>
                <ul>
                  <li>
                    <Link to="/parents">Benefits</Link>
                  </li>
                  <li>
                    <Link to="/workshops">Workshops</Link>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="white link pointer p-0"
                      onClick={openIntercomMessage(
                        "I'm a parent and I have some questions",
                      )}
                    >
                      Support
                    </button>
                  </li>
                </ul>
              </div>
              <div className="mb-3 pr-4 col-xl-3 col-sm-6">
                <h5>Students</h5>
                <ul>
                  <li>
                    <Link to="/login">Sign In</Link>
                  </li>
                  <li>
                    <Link to="/sel-encyclopedia">About SEL</Link>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="white link pointer p-0"
                      onClick={openIntercomMessage(
                        "I'm a student and I need help",
                      )}
                    >
                      Help
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </footer>
);

export default Footer;
